import React, { useEffect, useRef, useState } from 'react';
import { ExternalLink, Link2, Maximize2, Minimize2, Play, Rotate3d, Globe } from 'lucide-react';

/* Visor de una web de Lisual (editor.lisual.com/p/...) adentro de la plataforma. Lo usan Recorrido 360° y Página web.
   Alto fijo que llena la pantalla (no aspect-ratio: con alto máximo el navegador achicaba el ancho y quedaba una
   franja blanca y el menú de pisos aplastado). "Pantalla completa" agranda el visor sin salir de LisualPro. */
export default function VisorWeb({ url, video, titulo, tipo = '360' }) {
  const [modo, setModo] = useState(url ? 'web' : 'video');
  const [copiado, setCopiado] = useState(false);
  const [completa, setCompleta] = useState(false);
  const caja = useRef(null);
  const abrir = url || video;

  useEffect(() => {
    const salir = () => setCompleta(document.fullscreenElement === caja.current);
    document.addEventListener('fullscreenchange', salir);
    return () => document.removeEventListener('fullscreenchange', salir);
  }, []);

  const copiar = () => {
    if (!navigator.clipboard) return;
    navigator.clipboard.writeText(abrir).then(() => { setCopiado(true); setTimeout(() => setCopiado(false), 1800); }).catch(() => {});
  };
  const pantallaCompleta = () => {
    const el = caja.current;
    if (document.fullscreenElement) { document.exitFullscreen().catch(() => {}); return; }
    if (el && el.requestFullscreen) el.requestFullscreen().catch(() => window.open(abrir, '_blank', 'noopener'));
    else window.open(abrir, '_blank', 'noopener');
  };
  const nombreWeb = tipo === '360' ? 'Recorrido interactivo' : 'Página web';
  const IconoWeb = tipo === '360' ? Rotate3d : Globe;

  return (
    <div ref={caja} className={`bg-white overflow-hidden flex flex-col ${completa ? '' : 'border border-gray-200 rounded-2xl'}`}>
      <div className="flex flex-wrap items-center justify-between gap-2 px-4 py-2.5 border-b border-gray-100">
        <div className="flex items-center gap-1 bg-gray-100 rounded-full p-1">
          {url && (
            <button type="button" onClick={() => setModo('web')} className={`px-3 py-1 rounded-full text-sm font-medium inline-flex items-center gap-1.5 ${modo === 'web' ? 'bg-white text-blue-700 shadow-sm' : 'text-gray-600'}`}><IconoWeb size={14} />{nombreWeb}</button>
          )}
          {video && (
            <button type="button" onClick={() => setModo('video')} className={`px-3 py-1 rounded-full text-sm font-medium inline-flex items-center gap-1.5 ${modo === 'video' ? 'bg-white text-blue-700 shadow-sm' : 'text-gray-600'}`}><Play size={14} />Video</button>
          )}
        </div>
        <div className="flex items-center gap-4 text-sm">
          <button type="button" onClick={copiar} className="inline-flex items-center gap-1.5 font-medium text-gray-600 hover:text-gray-800"><Link2 size={15} />{copiado ? 'Link copiado' : 'Copiar link'}</button>
          <a href={abrir} target="_blank" rel="noopener noreferrer" className="hidden sm:inline-flex items-center gap-1.5 font-medium text-gray-600 hover:text-gray-800"><ExternalLink size={15} />Abrir aparte</a>
          <button type="button" onClick={pantallaCompleta} className="inline-flex items-center gap-1.5 font-medium text-blue-700 hover:underline">
            {completa ? <><Minimize2 size={15} />Salir</> : <><Maximize2 size={15} />Pantalla completa</>}
          </button>
        </div>
      </div>
      <div className="relative bg-gray-900 w-full" style={completa ? { flex: 1 } : { height: 'clamp(420px, calc(100dvh - 210px), 900px)' }}>
        {modo === 'web' && url ? (
          <iframe key={url} src={url} title={`${nombreWeb} · ${titulo || ''}`} className="absolute inset-0 w-full h-full border-0"
            allow="fullscreen; accelerometer; gyroscope; magnetometer; xr-spatial-tracking; autoplay" allowFullScreen />
        ) : (
          <video key={video} src={video} controls playsInline className="absolute inset-0 w-full h-full object-contain bg-black" />
        )}
      </div>
    </div>
  );
}
